import React from 'react';
import PropTypes from 'prop-types';
import { ContentCard } from '@/pages/inside/tenant/style';

import UserAvatar from '@/components/ui/UserAvatar';

const TeamWorkloadCard = ({ workloads, title = 'Team Workload' }) => {
    const list = workloads && workloads.length > 0 ? workloads : [];

    return (
        <ContentCard $padding="24px" style={{ height: '100%', minHeight: 280 }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--ant-color-text, #111827)', margin: '0 0 20px 0', fontFamily: 'var(--font-family-geist)' }}>
                {title}
            </h3>
            {list.length === 0 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150, color: 'var(--ant-color-text-secondary, #6b7280)', fontSize: 14, fontWeight: 500 }}>
                    N/A
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {list.map((item) => {
                        const percentage = Math.min(((item.completed || 0) / (item.total || 1)) * 100, 100);
                        return (
                            <div key={item.id} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                                <div style={{ minWidth: 160, display: 'flex', alignItems: 'center' }}>
                                    <UserAvatar
                                        name={item.name}
                                        role={item.role}
                                        imageUrl={item.imageUrl}
                                        initials={item.initials || (item.name ? item.name.charAt(0) : 'U')}
                                        avatarBg={item.avatarBg}
                                        forceExpand={true}
                                    />
                                </div>
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 4 }}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <span style={{ fontSize: 12, fontWeight: 600, color: '#111827', fontFamily: 'var(--font-family-geist)' }}>
                                            {item.completed} / {item.total} tasks
                                        </span>
                                    </div>
                                    <div style={{ position: 'relative', height: 8, background: '#ede9fe', borderRadius: 4, overflow: 'hidden' }}>
                                        <div style={{
                                            height: '100%',
                                            background: item.barBg || '#e76f51',
                                            width: `${percentage}%`,
                                            borderRadius: 4,
                                            transition: 'width 0.3s ease',
                                        }} />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </ContentCard>
    );
};

TeamWorkloadCard.propTypes = {
    workloads: PropTypes.array,
    title: PropTypes.string,
};

export default TeamWorkloadCard;
